<script setup lang="ts">
/**
 * What a till shows while a dialog's chunk is still arriving.
 *
 * Before this it showed nothing: `defineAsyncComponent` renders no fallback
 * unless given one, so pressing "Zaplatit" on a slow connection left the screen
 * exactly as it was. A server cannot tell that apart from a press that did not
 * register, and presses again.
 *
 * It is a dialog-shaped block rather than a spinner, so when the real one
 * arrives it replaces something the same size instead of pushing the screen
 * around — and it is inside the real scrim, so the page behind is already
 * inert and already scroll-locked by `GfDialog`.
 *
 * NO COPY. There is no translator in scope here (this is constructed at module
 * level, before `main.ts` has negotiated a locale) and a hard-coded Czech
 * "Načítám…" is the kind of string that survives into production in the one
 * language it was written for. The `aria-busy` region is what announces it;
 * `GfSkeleton` is deliberately `aria-hidden`.
 */
import { GfDialog, GfSkeleton } from "@gf/ui";
</script>

<template>
  <!--
    `closeOnEscape` stays ON. A chunk that never arrives — a bad network, a
    cache miss offline — would otherwise be a dialog with no way out, which is
    the worst possible thing to put in front of somebody mid-service.
  -->
  <GfDialog label="…" aria-busy="true">
    <div class="loading" role="status">
      <GfSkeleton :lines="1" height="1.6em" :ragged="false" />
      <GfSkeleton :lines="3" height="1.2em" />
      <GfSkeleton :lines="2" height="3em" :ragged="false" />
    </div>
  </GfDialog>
</template>

<style scoped>
.loading {
  display: flex;
  flex-direction: column;
  gap: var(--gf-space-4);
  padding: var(--gf-space-5);
}
</style>
